import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { IoMdList } from "react-icons/io";
import { MdModeEditOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updatecurrentCatMenu } from "../redux/Product/ProductSlice";

const Menu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { product_all } = useSelector((store) => store.product);
  const { restaurant_all } = useSelector((store) => store.restaurant);

  const [selectedCategory, SetSelectedCategory] = useState("");
  const [selectedMenu, SetSelectedMenu] = useState("");
  const [selectedcatMenu, SetSelectedcatMenu] = useState([]);
  const [restaurent_category, Setrestaurent_category] = useState([]);
  const [product_by_menu, Setproduct_by_menu] = useState([]);

  useEffect(() => {
    if (restaurant_all.length > 0) {
      const find_resto = restaurant_all.find(
        (data) => data.mobile === Number(9692261322)
      );
      if (find_resto) {
        const cat_data = find_resto.categories[0];
        Setrestaurent_category([...find_resto.categories]);
        SetSelectedCategory(cat_data);
        const menu = find_resto.menu;
        const cat_menu = menu.filter((data) => data.category === cat_data);
        SetSelectedcatMenu(cat_menu);
      }
    }
  }, [restaurant_all]);

  useEffect(() => {
    if (selectedMenu) {
      const filter_data = product_all.filter(
        (data) => data.menu_type === selectedMenu
      );
      Setproduct_by_menu(filter_data);
    }
  }, [selectedMenu, product_all]);

  return (
    <>
      <div className="page_header">
        <h4>Menu</h4>
      </div>

      <div className="menu_container">
        <div className="menu_main_box">
          <div className="menu_main_box_header">
            <div className="mn_hd_box">
              <div className="mn_hd_titl">
                <h5>Categories</h5>
              </div>
              <div className="mn_hd_icon_box">
                <Link to="/admin/add-category">
                  <div className="iconbox_mn">
                    <FaPlus className="menu_hd_icon" />
                  </div>
                </Link>
                <Link to="/admin/list-category">
                  <div className="iconbox_mn">
                    <IoMdList className="menu_hd_icon" />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <div className="menu_list_box">
            <ul>
              {restaurent_category &&
                restaurent_category.map((data, index) => (
                  <li
                    className={selectedCategory === data ? "active_item" : ""}
                    key={index}
                  >
                    <span className="item_name">{data}</span>
                    <span className="item_ed_icon">
                      <MdModeEditOutline className="ed_icon" />
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="menu_main_box">
          <div className="menu_main_box_header">
            <div className="mn_hd_box">
              <div className="mn_hd_titl">
                <h5>{selectedCategory}</h5>
              </div>
              <div className="mn_hd_icon_box">
                <Link to="/admin/menu-list">
                  <div className="iconbox_mn">
                    <FaPlus className="menu_hd_icon" />
                  </div>
                </Link>
                <Link to="/admin/menu-list">
                  <div className="iconbox_mn">
                    <IoMdList className="menu_hd_icon" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="menu_list_box">
            <ul>
              {selectedcatMenu.map((data, index) => (
                <li
                  className={selectedMenu === data.name ? "active_item" : ""}
                  key={index}
                  onClick={() => SetSelectedMenu(data.name)}
                >
                  <span className="item_name">{data.name}</span>
                  <Link to={`/admin/update-menu/${data._id}`}>
                    <span className="item_ed_icon">
                      <MdModeEditOutline className="ed_icon" />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {selectedMenu && (
          <div className="menu_main_box">
            <div className="menu_main_box_header">
              <div className="mn_hd_box">
                <div className="mn_hd_titl">
                  <h5>{selectedMenu}</h5>
                </div>
                <div className="mn_hd_icon_box">
                  <div
                    className="iconbox_mn"
                    onClick={() => {
                      navigate("/admin/product-add");
                      const formdata = {
                        current_category: selectedCategory,
                        current_menu: selectedMenu,
                      };
                      dispatch(updatecurrentCatMenu(formdata));
                    }}
                  >
                    <FaPlus className="menu_hd_icon" />
                  </div>

                  <Link to="/admin/product-list">
                    <div className="iconbox_mn">
                      <IoMdList className="menu_hd_icon" />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="menu_list_box">
              <ul>
                {product_by_menu &&
                  product_by_menu.map((data, index) => (
                    <li className="" key={index}>
                      <span className="item_name">{data.name}</span>
                      {/* <Link to={`/admin/update-menu/${data._id}`}> */}
                      <span className="item_ed_icon">
                        <MdModeEditOutline className="ed_icon" />
                      </span>
                      {/* </Link> */}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        )}
      </div>
      <div className="sub_cat_div">
        <div className="subcat_box">
          <Link to="/admin/add-subcategory">
            <h4>Create Sub-Category</h4>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Menu;
